import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';
import { BestPracticesCardModule } from '@main-client/src/app/best-practices-card/best-practices-card.module';
import { EditHubSegmentationItemsDrawerModule } from '@main-client/src/app/edit-hub-segmentation-items-drawer/edit-hub-segmentation-items-drawer.module';
import { MembersModule } from '@main-client/src/app/members/members.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { HubConfigSegmentationDrawerService } from './hub-config-segmentation-drawer/hub-config-segmentation-drawer.service';

import { HubConfigSegmentationDrawerComponent } from './hub-config-segmentation-drawer/hub-config-segmentation-drawer.component';
import { HubConfigSegmentationComponent } from './hub-config-segmentation.component';

@NgModule({
  declarations: [
    HubConfigSegmentationComponent,
    HubConfigSegmentationDrawerComponent,
  ],
  exports: [HubConfigSegmentationComponent],
  imports: [
    BestPracticesCardModule,
    CommonModule,
    DragDropModule,
    EditHubSegmentationItemsDrawerModule,
    FlexLayoutModule,
    MatDialogModule,
    MatChipsModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MembersModule,
    NzIconModule,
    ReactiveFormsModule,
    TranslationLookupModule,
    TtcMatInputModule,
  ],
  providers: [HubConfigSegmentationDrawerService],
})
export class HubConfigSegmentationModule {}
